(function() {
	'use strict';

	angular.module('quantixApp').factory('FinancialSensitivityService',
			FinancialSensitivityService);

	FinancialSensitivityService.$inject = [ '$resource', '$q', '$http' ];

	function FinancialSensitivityService($resource, $q, $http) {

		var factory = {};
		var _getAnalyticsCompanyDetails = function(companyCode,units,companyIndustryId,sensitivitySegmentId,conFlag,fmsmFlag,ybmFlag) {
			 
			var deferred = $q.defer();
			var data = {
				companyCode : companyCode,
				units : units,
				companyIndustryId : companyIndustryId,
				sensitivitySegmentId : sensitivitySegmentId,
				consolidatedFlag : conFlag,
				fmsmFlag : fmsmFlag,
				ybmFlag :ybmFlag
			};
			var url = 'api/financialSensitivity/getCompanyFinancialSensitivityDetails';

			$http.post(url, data).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _getFinancialCompanyDataPresentOrNot = function(companyCode,companyflag) {
			var data={companyCode:companyCode,
				companyflag:companyflag};
			var deferred = $q.defer();

			var url = 'api/financialSensitivity/getFinancialCompanyDataPresentOrNot';

			$http.post(url,data).then(function(response) {
				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		
		var _chekAlertFlag = function(companyCode) {
			var data={companyCode:companyCode};
			var deferred = $q.defer();

			var url = 'api/financialSensitivity/checkAlertFlag';

			$http.post(url,data).then(function(response) {
				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		
		var _getLandingPageData = function(fmsmFlag) {
			
			var deferred = $q.defer();

			var url = 'api/financialSensitivity/getLandingPageData';

			$http.post(url,fmsmFlag).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		
		
	
		
		var _sendEmailToUser = function() {

			var deferred = $q.defer();
			var url = 'api/financialSensitivity/financialSensitivitysendEmailToUser';
			$http.post(url).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;

		}
		
		/*var _getExportQtrlyPerfTrendDetails  = function(companyCode,companyIndustryId,sensitivitySegmentId) {

			var deferred = $q.defer();

			var url = 'api/financialSensitivity/getExportQtrlyPerfTrendDetails';

			$http.get(url, {
				params : {
					companyCode : companyCode,
					companyIndustryId:companyIndustryId,
					sensitivitySegmentId:sensitivitySegmentId
				}
			}).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}*/
		
		var _getCompaniesListByNameNew = function(searchText, module) {

			var deferred = $q.defer();

			var url = 'api/financialSensitivity/getCompaniesByName';

			$http.get(url, {
				params : {
					searchText : searchText,
					module : module
				},
				ignoreLoadingBar : true
			}).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		
		var _getCompanyRecentlyViewedList = function(userRecentlyViewedCompany){
			var deferred = $q.defer();
			var url =  'api/financialSensitivity/getCompanyRecentlyViewed';		
			$http.post(url,userRecentlyViewedCompany).then(function(response) {	
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		
		
		var _saveRecentlyViewedCompany = function(userRecentlyViewedCompany) {
			return $http({
				method : 'POST',
				url : 'api/financialSensitivity/saveRecentlyViewedCompany',
				headers : {
					'Content-type' : 'application/json'
				},
				data : userRecentlyViewedCompany
			})
					.success(function(data) {
					})
					.error(
							function(data) {
								console
										.log("Error in save Recently Viewed Company Angular Service"
												+ data);

							});
		}
		
		var _getUserViewedCount = function(){
			var deferred = $q.defer();
			var url =  'api/financialSensitivity/getUsageCount';		
			$http.post(url).then(function(response) {	
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		
		var _getCompanyDetails= function(companyCode){
			var deferred = $q.defer();
			var url =  'api/financialSensitivity/companydetails';
			$http.post(url,{'companyCode':companyCode}).then(function(response) {	
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		
		var _excludeIndustriesForExport= function(){
			var deferred = $q.defer();
			var url =  'api/financialSensitivity/excludeIndustriesForExport';
			$http.post(url).then(function(response) {	
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		
		var _getSelectedCompanyDetails = function(companyCode, module) {

			var deferred = $q.defer();

			var url = 'api/financialSensitivity/getSelectedCompanyDetails';

			$http.get(url, {
				params : {
					searchText : companyCode,
					module : module
				},
				ignoreLoadingBar : true
			}).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		
		var _financialSensitivityExportModelForCIR = function(fd) {
			var deferred = $q.defer();
			var filePathURL = 'api/financialSensitivity/financialSensitivityExportModelForCIR';
			
			$http.post(filePathURL, fd, {
				transformRequest : angular.identity,
				headers : {
					'Content-Type' : undefined
				}
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;

		}
		
		var _getTopCompaniesAcrossSector = function () {
			var deferred = $q.defer();
			var url = 'api/financialSensitivity/fsmNews/getTopCompaniesAcrossSector';
			$http.post(url).then(function (response) {
			deferred.resolve(response.data);
			}, function (errResponse) {
			deferred.reject(errResponse);
			});
			return deferred.promise;
			}

			var _getSectoralNewsClassificationDetails = function (inputObj) {
			var deferred = $q.defer();
			var url = 'api/financialSensitivity/fsmNews/getSectoralNewsClassificationDetails';
			$http.post(url, inputObj).then(function (response) {
			deferred.resolve(response.data);
			}, function (errResponse) {
			deferred.reject(errResponse);
			});
			return deferred.promise;
			}

			
			var _getFsmNewsClassificationGraph = function (inputObj) {
				var deferred = $q.defer();
				var url = 'api/financialSensitivity/fsmNews/getNewsClassificationGraphDetails';
				$http.post(url, inputObj).then(function (response) {
				deferred.resolve(response.data);
				}, function (errResponse) {
				deferred.reject(errResponse);
				});
				return deferred.promise;
				}
			
		return {

			getAnalyticsCompanyDetails : _getAnalyticsCompanyDetails,
			getFinancialCompanyDataPresentOrNot : _getFinancialCompanyDataPresentOrNot,
			getLandingPageData:_getLandingPageData,
			chekAlertFlag:_chekAlertFlag,
			sendEmailToUser:_sendEmailToUser,
			getCompaniesListByNameNew : _getCompaniesListByNameNew,
			getCompanyRecentlyViewedList:_getCompanyRecentlyViewedList,
			saveRecentlyViewedCompany:_saveRecentlyViewedCompany,
			getUserViewedCount: _getUserViewedCount,
			getCompanyDetails:_getCompanyDetails,
			excludeIndustriesForExport:_excludeIndustriesForExport,
			getSelectedCompanyDetails:_getSelectedCompanyDetails,
			getTopCompaniesAcrossSector:_getTopCompaniesAcrossSector,
			getSectoralNewsClassificationDetails: _getSectoralNewsClassificationDetails,
			financialSensitivityExportModelForCIR:_financialSensitivityExportModelForCIR,
			getFsmNewsClassificationGraph:_getFsmNewsClassificationGraph
		};

	}
})();
